import { render, staticRenderFns } from "./SiblingTable.vue?vue&type=template&id=42ef38c8&scoped=true&"
import script from "./SiblingTable.vue?vue&type=script&lang=js&"
export * from "./SiblingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ef38c8",
  null
  
)

export default component.exports